document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.view-toggle-wrap').forEach(function(el) { el.remove(); });

  function createToggle() {
    var wrap = document.createElement('div');
    wrap.className = 'view-toggle-wrap';
    wrap.innerHTML = '<button type="button" class="view-toggle-btn active" data-view="item">Item View</button><button type="button" class="view-toggle-btn" data-view="model">Model View</button>';
    return wrap;
  }

  var filterBar = document.querySelector('.filter-bar__inner');
  if (filterBar) filterBar.appendChild(createToggle());

  var mobileGroup = document.querySelector('.mobile-filters__group');
  if (mobileGroup) mobileGroup.insertBefore(createToggle(), mobileGroup.firstChild);

  var savedView = localStorage.getItem('productView') || 'item';
  applyView(savedView);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.view-toggle-btn');
    if (!btn) return;
    applyView(btn.dataset.view);
    localStorage.setItem('productView', btn.dataset.view);
  });

  function applyView(view) {
    document.querySelectorAll('.view-toggle-btn').forEach(function (b) {
      b.classList.toggle('active', b.dataset.view === view);
    });
    document.body.classList.toggle('model-view', view === 'model');

    document.querySelectorAll('.product-item__media').forEach(function (media) {
      var one = media.querySelector('.product-item__image--one');
      var two = media.querySelector('.product-item__image--two');
      if (!one || !two) return;
      if (view === 'model') {
        one.style.setProperty('opacity', '0', 'important');
        one.style.setProperty('position', 'absolute');
        one.style.setProperty('top', '0');
        one.style.setProperty('left', '0');
        one.style.setProperty('width', '100%');
        one.style.setProperty('height', '100%');
        two.style.setProperty('opacity', '1', 'important');
        two.style.setProperty('position', 'relative');
        two.style.setProperty('z-index', '2');
      } else {
        one.style.removeProperty('opacity');
        one.style.removeProperty('position');
        one.style.removeProperty('top');
        one.style.removeProperty('left');
        one.style.removeProperty('width');
        one.style.removeProperty('height');
        two.style.removeProperty('opacity');
        two.style.removeProperty('position');
        two.style.removeProperty('z-index');
      }
    });
  }

  var hoverObserver = new MutationObserver(function(mutations) {
    if (!document.body.classList.contains('model-view')) return;
    if (window.innerWidth < 720) return;
    mutations.forEach(function(m) {
      if (m.type !== 'attributes' || m.attributeName !== 'class') return;
      var el = m.target;
      var media = el.closest('.product-item__media');
      if (!media) return;
      var one = media.querySelector('.product-item__image--one');
      var two = media.querySelector('.product-item__image--two');
      if (!one || !two || el !== two) return;
      if (two.classList.contains('active')) {
        one.style.setProperty('opacity', '1', 'important');
        one.style.setProperty('z-index', '5', 'important');
        two.style.setProperty('opacity', '0', 'important');
      } else {
        one.style.setProperty('opacity', '0', 'important');
        one.style.removeProperty('z-index');
        two.style.setProperty('opacity', '1', 'important');
      }
    });
  });

  hoverObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true
  });

  function showSwatches() {
    document.querySelectorAll('.product-swatches-options').forEach(function(el) {
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
    });
  }
  showSwatches();
  setTimeout(showSwatches, 500);
  document.addEventListener('collection:updated', showSwatches);

});